import { render, staticRenderFns } from "./RentalCompanyView.vue?vue&type=template&id=ed656440&"
import script from "./RentalCompanyView.vue?vue&type=script&lang=js&"
export * from "./RentalCompanyView.vue?vue&type=script&lang=js&"
import style0 from "./RentalCompanyView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports